import { useMemo } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataClickArea,
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventClickAccordion,
} from 'src/types/googleAnalyticsEvents';

export function useEventClickAccordion(itemTitle: string): AnalyticsEventClickAccordion {
  const trackedPageContext = useTrackedPageContext();

  return useMemo(
    () => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.clickAccordion,
      [AnalyticsDataProperty.clickArea]: AnalyticsDataClickArea.content,
      [AnalyticsDataProperty.clickPath]: itemTitle,
      ...trackedPageContext,
    }),
    [itemTitle, trackedPageContext],
  );
}
